export const IDENTITY_RESTAURATEUR = 'restaurateur';
export const IDENTITY_ADMIN = 'admin';
